export type StepStaticCardsResponse = {
	openRequests: number;
	closedRequests: number;
	unassignedRequests: number;
	overdueRequests: number;
	openRequestsPercentageChange: number;
	closedRequestsPercentageChange: number;
	unassignedRequestsPercentageChange: number;
	overdueRequestsPercentageChange: number;
};

export enum StepStatus {
	Unknown = 0,
	Unassigned = 1,
	Assigned = 2,
	Closed = 3,
	Overdue = 4,
}

export interface SupervisorStepsQueryParams {
	page: number;
	pageSize: number;
	departmentId: string;
	from?: string;
	to?: string;
	stepStatus: StepStatus;
	userIds?: string[];
}
